import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '../Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  clickAway: {
    backgroundColor: 'transparent',
    border: 'none',
    height: 'calc(100vh - 100px)',
    width: '100vw',
    position: 'absolute',
    zIndex: 998,
  },
  root: {
    width: '100vw',
    position: 'absolute',
    borderTop: `1px solid ${theme.palette.common.battleshipGrey}`,
    borderBottom: `1px solid ${theme.palette.common.battleshipGrey}`,
    backgroundColor: theme.palette.common.white,
    left: 0,
    padding: '2rem',
    zIndex: 999,
  },
  container: {
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 0.5rem',
  },
  button: {
    marginLeft: '1rem',
    fontSize: '1rem',
  },
  text: {
    marginRight: '1.5rem',
  },
}));

const AuthMenu = ({authMenu, setAuthMenu}) => {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  const handleClick = (userType) => {
    if (userType === 'participant') {
      if (authMenu === 'login') {
        history.push({pathname: '/login', state:{redirectTo}});
      } else {
        history.push('/signup');
      }
    } else {
      if (authMenu === 'login') {
        history.push({pathname: '/providers', state:{redirectTo}});
      } else {
        history.push('/providers/signup');
      }
    }
    setAuthMenu(null);
  };

  const closeOnEscape = (event) => {
    if (event.keyCode === 27) {
      setAuthMenu(null);
    }
  };

  return (
    <React.Fragment>
      <div className={classes.clickAway} onClick={()=>setAuthMenu(null)}/>
      <div className={classes.root}>
        <Container maxWidth="lg" fixed disableGutters={true}>
          <Grid item xs={12} onKeyUp={closeOnEscape}>
            <div className={classes.container}>
              <Typography variant="h3" color="primary" className={classes.text}>
                Select which user type you would like to <b>{authMenu === 'signup' ? 'Register' : 'Log In'}</b> as:
              </Typography>
              <Button
                label="I am a provider"
                onClick={()=>handleClick('provider')}
                variant="outlined"
                pointer="right"
                className={classes.button}
                disableRipple
              />
              <Button
                label="I am a NDIS participant"
                onClick={()=>handleClick('participant')}
                variant="contained"
                pointer="right"
                className={classes.button}
                disableRipple
              />
            </div>
          </Grid>
        </Container>
      </div>
    </React.Fragment>
  );
};

AuthMenu.propTypes = {
  authMenu: PropTypes.string,
  setAuthMenu: PropTypes.func.isRequired,
};

export default AuthMenu;
